/**
 * Fix per le etichette prodotto
 * Rimuove le etichette duplicate che vengono spostate dentro l'immagine dal JS del modulo
 * e mantiene solo quelle nella posizione corretta (dopo il prezzo)
 */

$(document).ready(function () {
    function fixProductLabels() {
        // Trova tutte le etichette dentro i link delle immagini (quelle spostate dal JS del modulo)
        // Per liste prodotto
        $('.product_img_link .seosa_product_label._catalog, .product_img_link .seosa_product_label[class*="_catalog"]').each(function () {
            var $label = $(this);
            var $productMiniature = $label.closest('.js-product-miniature, .ajax_block_product, article');

            // NON rimuovere "Classe A" - deve rimanere sopra l'immagine
            var isClasseA = $label.find('img[alt="Classe A"]').length > 0 || $label.attr('alt') === 'Classe A';
            if (isClasseA) {
                return; // Salta "Classe A", lasciala dove è
            }

            // Verifica se esiste già un'etichetta nella posizione corretta (dopo il prezzo)
            var $correctLabel = $productMiniature.find('.end .seosa_product_label:not(._catalog), .product-labels-inline .seosa_product_label');

            // Se esiste già un'etichetta nella posizione corretta, rimuovi quella dentro l'immagine
            if ($correctLabel.length > 0) {
                $label.remove();
            }
        });

        // Per pagina prodotto - rimuovi tutte le etichette da cover-image tranne "Classe A"
        $('.cover-image .seosa_product_label._catalog, .cover-image .seosa_product_label._product_page, .cover-image .seosa_product_label[class*="_catalog"], .cover-image .seosa_product_label[class*="_product_page"]').each(function () {
            var $label = $(this);

            // NON rimuovere "Classe A" - deve rimanere sopra l'immagine
            var isClasseA = $label.find('img[alt="Classe A"]').length > 0 || $label.attr('alt') === 'Classe A';
            if (isClasseA) {
                return; // Salta "Classe A", lasciala dove è
            }

            // Rimuovi sempre tutte le altre etichette da cover-image (devono essere solo in product-labels-section)
            $label.remove();
        });
    }

    // Esegui subito al caricamento
    fixProductLabels();

    // Esegui anche dopo che il modulo seosaproductlabels ha spostato le etichette
    // Il modulo esegue il suo JS dopo il DOM ready, quindi aspettiamo un po'
    setTimeout(fixProductLabels, 100);
    setTimeout(fixProductLabels, 300);
    setTimeout(fixProductLabels, 500);
    setTimeout(fixProductLabels, 1000);

    // Esegui anche dopo eventi AJAX (quando vengono caricati nuovi prodotti)
    $(document).ajaxComplete(function () {
        setTimeout(fixProductLabels, 100);
        setTimeout(fixProductLabels, 500);
    });

    // Usa MutationObserver per intercettare quando le etichette vengono aggiunte dinamicamente
    var observer = new MutationObserver(function (mutations) {
        var shouldFix = false;
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) { // Element node
                        var $node = $(node);
                        if ($node.hasClass('seosa_product_label') || $node.find('.seosa_product_label').length > 0) {
                            shouldFix = true;
                        }
                    }
                });
            }
        });
        if (shouldFix) {
            setTimeout(fixProductLabels, 50);
        }
    });

    // Osserva il body per intercettare quando vengono aggiunte etichette
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});

